/**
 * Consent Management feature — public API.
 *
 * Import the feature's surface from `@consent` (barrel). Internal files should
 * import each other via the granular `@consent/*` subpaths to avoid cycles.
 */
export * from './models/consent-form.model';
export * from './constants/consent.constants';
export * from './services/consent-form.service';
export * from './components/consent-form-dialog/consent-form-dialog.component';
